import { render, staticRenderFns } from "./preference-link-tab.vue?vue&type=template&id=3a91a7ee"
import script from "./preference-link-tab.vue?vue&type=script&lang=js"
export * from "./preference-link-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports